module.exports = __webpack_public_path__ + "logo_green.png";